import { SqButton } from "@/components/squircle-ui/button";
import { RiPencilLine } from "@remixicon/react";

interface EditMetricsToggleProps {
  active: boolean;
  onToggle: () => void;
  size?: "sm" | "md";
}

const EditMetricsToggle = ({ active, onToggle, size = "md" }: EditMetricsToggleProps) => {
  return (
    <SqButton
      size={size}
      variant={"outline"}
      hasOutline
      bgColor="white"
      hoverBgColor="#FBFBFB"
      className="flex items-center justify-center p-1 shadow-sm"
      onClick={onToggle}
    >
      <div
        className={`gap-1 px-[6px] h-full flex items-center justify-center 
          ${active ? "border border-[#FFDACC] bg-[#FFF0EB] rounded-[4px]" : ""}
        `}
      >
        <RiPencilLine
          size={14}
          color={active ? "#FF4500" : "#9AA3BD"}
          className="shrink-0"
        />
        <span
          className={`not-italic text-[12px] font-medium text-brand-primary-800 tracking-[0.02em] translate-y-[1px]  ${
            active && "!text-[#FF4500]"
          }`}
        >
          Edit Columns
        </span>
      </div>
    </SqButton>
  );
};

export default EditMetricsToggle;
